import { useOrderApiV1 } from '../../../clients/quipli-service/order/order-api-v1';
import { Order } from '../../../clients/quipli-service/order/order';
import { toast } from '../../../util/toasts';
import { Modal } from '../../../components/modal/modal';
import { OrderCycleBillingTermsForm } from '../cycle-billing-terms/cycle-billing-terms';
import { Duration } from 'luxon';
import { useState } from 'react';
import { Button } from '../../../components/form/button';

const initialCycleBillingTermsState = {
  cycleLength: Duration.fromObject({ days: 28 }),
  paymentPeriod: Duration.fromObject({ days: 30 }),
  cycleInvoiceDay: 28,
  isDayOfMonth: false,
};

export const ConvertToCycleBillingModal = ({
  order,
  onConfirm,
  onClose,
}: {
  order: Order;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) => {
  const { convertContractToCycleBilling } = useOrderApiV1();

  const [isEditingCycleBillingTerms, setIsEditingCycleBillingTerms] = useState<boolean>(false);
  const [cycleBillingTerms, setCycleBillingTerms] = useState({
    global: initialCycleBillingTermsState,
    order: initialCycleBillingTermsState,
    state: initialCycleBillingTermsState,
  });

  const handleConvert = async () => {
    if (isEditingCycleBillingTerms) return;

    try {
      await convertContractToCycleBilling(order.id, cycleBillingTerms.order);
      await onConfirm();
    } catch (err: any) {
      toast(err.message || 'Failed to convert to cycle billing', 'error');
    }
  };

  return (
    <>
      <Modal
        isOpen={true}
        title="Convert to Cycle Billing"
        close={onClose}
        actions={
          <>
            <Button onClick={onClose} className="button-secondary" disabled={isEditingCycleBillingTerms}>
              Cancel
            </Button>
            <Button onClick={handleConvert} className="button-yellow" disabled={isEditingCycleBillingTerms}>
              Convert
            </Button>
          </>
        }
      >
        <OrderCycleBillingTermsForm
          hideCheckbox
          isChecked
          disableSaveCustomerCycleBillingTerms
          customer={order.user}
          isEditing={isEditingCycleBillingTerms}
          cycleBillingTerms={cycleBillingTerms}
          setIsEditing={setIsEditingCycleBillingTerms}
          setCycleBillingTerms={setCycleBillingTerms}
        />
      </Modal>
    </>
  );
};
